export default __webpack_public_path__ + "static/media/SAS0090.34I-41816_-25104_0.62cc276f.jpg";